/** Refused (told to MPS) or cancelled: nothing may change these batches any more. */
export const LOCKED_STATUSES: readonly string[] = ['Refused', 'Cancelled'];

/** No work left: the locked statuses, and finished ones. Mirrors BatchStatuses on the API. */
export const CLOSED_STATUSES: readonly string[] = ['Completed', 'Incomplete', ...LOCKED_STATUSES];

/** A Batch Pick batch: picked and verified on its own screens. The API sends the type by name or number. */
export function isBatchPick(batch: { batchType?: unknown } | null | undefined): boolean {
  return batch?.batchType === 'BatchPick' || batch?.batchType === 1;
}
